// Mirrors Boom::PortalAPI::BoomCRM::UtmRule::* entities (boompay-api, CRM-1545).

export enum UtmTag {
  Source = "source",
  Medium = "medium",
  Campaign = "campaign",
  Term = "term",
  Content = "content"
}

export enum UtmMatchType {
  Is = "is",
  Contains = "contains"
}

export type UtmCondition = {
  tag: UtmTag;
  match_type: UtmMatchType;
  value: string;
};

export type UtmRuleLeadSource = {
  id: number;
  name: string;
  color: string | null;
  source_type: "boom" | "partner";
  // False once the source was deleted, turned off or protected: the rule then
  // matches nothing until it points at another source.
  assignable: boolean;
};

export type UtmRule = {
  id: number;
  position: number;
  conditions: UtmCondition[];
  lead_source_id: number;
  lead_source: UtmRuleLeadSource | null;
  assigned_count_30d: number;
  created_at: string;
  updated_at: string;
};

export type UtmRulePayload = {
  lead_source_id: number;
  conditions: UtmCondition[];
};

export type UnmatchedUtmValue = {
  source: string | null;
  medium: string | null;
  campaign: string | null;
  lead_count: number;
  suggested_lead_source: UtmRuleLeadSource | null;
};

// What the Add rule dialog opens with: blank, a row from "UTM values without a
// rule", or an existing rule being edited.
export type UtmRuleDraft = {
  conditions: UtmCondition[];
  lead_source_id?: number;
};
